var variantImageAutomator = function () {
  function create_element_append_to_body(el, elId, display) {
    display || (display = "none");
    var g = document.createElement(el);
    (g.id = elId),
      (g.style = "display:" + display),
      document.body.appendChild(g);
  }
  function find_current_variant(section) {
    var variant_id,
      element = section || document;
    default_variant =
      0 == default_variant ? Object.keys(product_variants)[0] : default_variant;
    var queries = {};
    if (
      (document.location.search
        .substr(1)
        .split("&")
        .forEach(function (q) {
          var i = q.split("=");
          try {
            queries[i[0].toString()] = i[1].toString();
          } catch (err) {}
        }),
      isNaN(queries.variant))
    ) {
      let selector =
        element.querySelector('form[action="/cart/add"] [name="id"]:checked') ||
        element.querySelector('form[action="/cart/add"] [name="id"]') ||
        element.querySelector('select[name="id"]') ||
        element.querySelector('[name="id"]');
      variant_id = selector ? selector.value : default_variant;
    } else
      variant_id = queries.variant
        ? queries.variant
        : element.querySelector(
            "select option[value='" + default_variant + "']"
          ).parentNode.value;
    return variant_id || default_variant;
  }
  function is_variant_in_url() {
    return document.location.search.indexOf("variant=") >= 0;
  }
  function find_current_variant_from_url() {
    var variant_id,
      queries = {};
    return (
      document.location.search
        .substr(1)
        .split("&")
        .forEach(function (q) {
          var i = q.split("=");
          try {
            queries[i[0].toString()] = i[1].toString();
          } catch (err) {}
        }),
      isNaN(queries.variant)
        ? (variant_id = null)
        : queries.variant && (variant_id = queries.variant),
      variant_id
    );
  }
  function find_variant_images(variant_id) {
    var variant_images;
    if (
      (variant_id || (variant_id = find_current_variant()),
      variants.hasOwnProperty(variant_id)
        ? (variant_images = variants[variant_id])
        : ((variant_id = find_current_variant_from_url()),
          (variant_images = variants.hasOwnProperty(variant_id)
            ? variants[variant_id]
            : variants[default_variant])),
      (!variant_images || 0 == variant_images.length) &&
        skip_showcase_image >= product_images.length)
    )
      return product_images;
    if (
      !is_home &&
      "no_action" != only_run_if_variant_in_url &&
      !is_variant_in_url()
    ) {
      function showcase_images() {
        return variants.g.length ? variants.g : variant_assigned_images;
      }
      function skipped_and_showcase_images() {
        let images = variants.skipped.concat(variants.g);
        return images.length ? images : variant_assigned_images;
      }
      if (((selection_vid = 0), "showcase_only" == only_run_if_variant_in_url))
        return showcase_images();
      if ("showcase_and_variants" == only_run_if_variant_in_url)
        return variants.g.concat(variant_assigned_images);
      if ("featured_only" == only_run_if_variant_in_url)
        return [product_images[0]];
      if ("featured_and_showcase" == only_run_if_variant_in_url)
        return skip_showcase_image > 0
          ? [product_images[0]].concat(variants.g)
          : showcase_images();
      if ("skipped_and_showcase" == only_run_if_variant_in_url)
        return skipped_and_showcase_images();
      if ("show_all" == only_run_if_variant_in_url) return product_images;
    }
    return (
      "at_start" == general_images_position
        ? (variant_images = variants.g.concat(variant_images))
        : "at_end" == general_images_position &&
          (variant_images = variant_images.concat(variants.g)),
      variant_images && 0 != variant_images.length
        ? variant_images
        : product_images
    );
  }
  function is_array_equal(a1, a2) {
    return JSON.stringify(a1) === JSON.stringify(a2);
  }
  function find_variant_media(variant_id) {
    var variant_media;
    if (
      (variant_id || (variant_id = find_current_variant()),
      variants_media.hasOwnProperty(variant_id)
        ? (variant_media = variants_media[variant_id])
        : ((variant_id = find_current_variant_from_url()),
          (variant_media = variants_media.hasOwnProperty(variant_id)
            ? variants_media[variant_id]
            : variants_media[default_variant])),
      (!variant_media || 0 == variant_media.length) &&
        skip_showcase_image >= product_media.length)
    )
      return product_media;
    if (
      !is_home &&
      "no_action" != only_run_if_variant_in_url &&
      !is_variant_in_url()
    ) {
      function showcase_images() {
        return variants_media.g.length
          ? variants_media.g
          : variant_assigned_media;
      }
      function skipped_and_showcase_images() {
        let images = variants_media.skipped.concat(variants_media.g);
        return images.length ? images : variant_assigned_media;
      }
      if (((selection_vid = 0), "showcase_only" == only_run_if_variant_in_url))
        return showcase_images();
      if ("showcase_and_variants" == only_run_if_variant_in_url)
        return variants_media.g.concat(variant_assigned_media);
      if ("featured_only" == only_run_if_variant_in_url)
        return [product_media[0]];
      if ("featured_and_showcase" == only_run_if_variant_in_url)
        return skip_showcase_image > 0
          ? [product_media[0]].concat(variants_media.g)
          : showcase_images();
      if ("skipped_and_showcase" == only_run_if_variant_in_url)
        return skipped_and_showcase_images();
      if ("show_all" == only_run_if_variant_in_url) return product_media;
    }
    return (
      "at_start" == general_images_position
        ? (variant_media = variants_media.g.concat(variant_media))
        : "at_end" == general_images_position &&
          (variant_media = variant_media.concat(variants_media.g)),
      variant_media && 0 != variant_media.length
        ? priority_video
          ? moveVideoToFront(variant_media)
          : variant_media
        : product_media
    );
  }
  function moveVideoToFront(arr) {
    const videoIndex = arr.findIndex(
      (obj) => "video" === obj.media_type || "external_video" === obj.media_type
    );
    if (videoIndex > -1) {
      const videoObj = arr.splice(videoIndex, 1)[0];
      arr.unshift(videoObj);
    }
    return arr;
  }
  var quick_view_enabled = !1,
    skip_showcase_image = 0,
    selected_theme_name = "Focal",
    priority_video = !1,
    can_execute_script = !1,
    is_home = !1,
    only_run_if_variant_in_url = "no_action",
    limit_on_product = "none",
    product_url = "",
    is_product_preview =
      window.location.href.toLowerCase().indexOf("/products_preview") >= 0,
    is_product_page = /\/products\/|\/produkty\/|\/produkte\//.test(
      window.location.href.toLowerCase()
    ),
    is_pages =
      ((is_home = "/" == window.location.pathname),
      window.location.pathname.indexOf("/pages/") >= 0),
    variant_id = 0,
    selection_vid = 0,
    last_variant_images = {};
  if (
    ((is_home || is_pages || is_product_page || is_product_preview) &&
      (can_execute_script = !0),
    quick_view_enabled)
  )
    var jTimer = setInterval(function () {
      window.$ && window.jQuery && clearInterval(jTimer);
    }, 10);
  if (can_execute_script) {
    if (is_home) {
      if ("Startup" == selected_theme_name)
        product_url = document.querySelector(
          '[data-section-type="featured-product"] .product-title a'
        )
          ? document.querySelector(
              '[data-section-type="featured-product"] .product-title a'
            ).href
          : "";
      else if ("Flow" == selected_theme_name)
        product_url = document.querySelector(
          "#product-box .product-details--form-wrapper a"
        )
          ? document.querySelector(
              "#product-box .product-details--form-wrapper a"
            ).href
          : "";
      else if ("Debut" == selected_theme_name);
      else if ("Success theme" == selected_theme_name);
      else if ("Supply V2" == selected_theme_name)
        product_url = document.querySelector(
          '[data-section-type="product-template"] a.full-details'
        )
          ? document.querySelector(
              '[data-section-type="product-template"] a.full-details'
            ).href
          : "";
      else if ("Launch" == selected_theme_name)
        product_url = document.querySelector(
          ".home-featured-product .product-title a"
        )
          ? document.querySelector(".home-featured-product .product-title a")
              .href
          : "";
      else if ("Responsive" == selected_theme_name)
        product_url = document.querySelector(
          ".featured-product-section .product_name a"
        )
          ? document.querySelector(".featured-product-section .product_name a")
              .href
          : "";
      else if ("Streamline" == selected_theme_name);
      else if ("Broadcast" == selected_theme_name)
        product_url = document.querySelector(
          '[data-section-type="product"] .product__title a'
        )
          ? document.querySelector(
              '[data-section-type="product"] .product__title a'
            ).href
          : "";
      else if ("Palo Alto V2" == selected_theme_name)
        product_url = document.querySelector(
          '[data-section-type="featured-product"]:first-child .featured-product-title a'
        )
          ? document.querySelector(
              '[data-section-type="featured-product"]:first-child .featured-product-title a'
            ).href
          : "";
      else if ("Startup V3" == selected_theme_name)
        product_url = document.querySelector(".product-title a")
          ? document.querySelector(".product-title a").href
          : "";
      else if (
        [
          "Turbo",
          "Turbo Seoul",
          "Turbo Florence",
          "Turbo Portland",
          "Turbo Chicago",
          "Turbo Dubai",
          "Turbo Tennessee",
        ].indexOf(selected_theme_name) >= 0
      )
        product_url = document.querySelector(".product_section .product_name a")
          ? document.querySelector(".product_section .product_name a").href
          : "";
      else if ("Palo Alto V3" == selected_theme_name)
        product_url = document.querySelector(
          '[data-section-type="featured-product"] .featured-product-title a'
        )
          ? document.querySelector(
              '[data-section-type="featured-product"] .featured-product-title a'
            ).href
          : "";
      else if ("Warehouse" == selected_theme_name)
        product_url = document.querySelector(
          '[data-section-type="product"]:last-child .product-meta__title a'
        )
          ? document.querySelector(
              '[data-section-type="product"]:last-child .product-meta__title a'
            ).href
          : "";
      else if ("Flex" == selected_theme_name)
        product_url = document.querySelector(
          ".shopify-section.featured-product-section.jsProduct .product-thumbnail__title a"
        )
          ? document.querySelector(
              ".shopify-section.featured-product-section.jsProduct .product-thumbnail__title a"
            ).href
          : "";
      else if (
        ["Empire V5.1", "Superstore V2"].indexOf(selected_theme_name) >= 0
      ) {
        let product_links = document.querySelectorAll(
          ".featured-product--container .product-link"
        );
        product_url = product_links.length
          ? product_links[product_links.length - 1].href
          : "";
      }
      product_url = product_url.replace(/\/$/, "").split("?")[0].split("#")[0];
    } else
      is_pages
        ? ("Broadcast" == selected_theme_name &&
            (product_url = document.querySelector(
              '[data-section-type="product"] .product__title a'
            )
              ? document.querySelector(
                  '[data-section-type="product"] .product__title a'
                ).href
              : ""),
          (product_url = product_url
            .replace(/\/$/, "")
            .split("?")[0]
            .split("#")[0]))
        : (product_url = window.location.pathname
            .replace(/\/$/, "")
            .replace("//", "/"));
    if (
      product_url.length &&
      (void 0 === window.via_product_handle ||
        window.via_product_handle != product_url)
    ) {
      var productJson;
      window.via_product_handle = product_url;
      var variants = {},
        product_variants = {};
      (variants.g = []), (variants.skipped = []);
      var product_images = [],
        default_variant = 0,
        general_images_position = "at_end",
        hide_single_thumb = !1,
        variant_assigned_images = [],
        variants_media = {},
        product_media = [];
      (variants_media.g = []), (variants_media.skipped = []);
      var variant_assigned_media = [],
        product_tags = "",
        variant_assigned_images_ids = [],
        variant_assigned_media_ids = [],
        all_variant_media = [],
        all_variant_images = [];
        var ql_all_variants = [];
        //   产品媒体图
      function assign_variants_media(productJson) {
        (product_media = ql_arr_hb_all_media ? ql_arr_hb_all_media : productJson.media),
        (ql_arr_hb_all_variants ? ql_all_variants = ql_arr_hb_all_variants : ql_all_variants = productJson.variants ),
        ql_arr_hb_all_variants.forEach(function (variant) {
            variant.featured_image &&
              -1 ==
                variant_assigned_images_ids.indexOf(
                  variant.featured_image.id
                ) &&
              (variant_assigned_images_ids.push(variant.featured_image.id),
              variant_assigned_images.push(variant.featured_image)),
              variant.featured_media &&
                -1 ==
                  variant_assigned_media_ids.indexOf(
                    variant.featured_media.id
                  ) &&
                (variant_assigned_media_ids.push(variant.featured_media.id),
                variant_assigned_media.push(variant.featured_media)),
              !default_variant &&
                variant.available &&
                (default_variant = variant.id),
              variant.featured_media &&
                (all_variant_media[variant.featured_media.id] ||
                  (all_variant_media[variant.featured_media.id] = []),
                all_variant_media[variant.featured_media.id].push(variant.id)),
              (variants_media[variant.id] = []),
              variant.featured_image &&
                (all_variant_images[variant.featured_image.id] ||
                  (all_variant_images[variant.featured_image.id] = []),
                all_variant_images[variant.featured_image.id].push(variant.id)),
              (variants[variant.id] = []),
              (product_variants[variant.id] = variant);
          });
        var general_media = !0,
          current_variant_ids = [];
        product_media.forEach(function (media, index) {
          general_media && -1 == variant_assigned_media_ids.indexOf(media.id)
            ? skip_showcase_image > 0 && index < skip_showcase_image
              ? variants_media.skipped.push(media)
              : variants_media.g.push(media)
            : ((general_media = !1),
              (current_variant_ids = all_variant_media[media.id]
                ? all_variant_media[media.id]
                : current_variant_ids).forEach(function (variant_id) {
                variants_media[variant_id].push(media);
              }));
        });
      }
      function assign_variant_images(images) {
        var general_images = !0,
          current_variant_ids = [];
        (product_images = images).forEach(function (image, index) {
          general_images && -1 == variant_assigned_images_ids.indexOf(image.id)
            ? skip_showcase_image > 0 && index < skip_showcase_image
              ? variants.skipped.push(image)
              : variants.g.push(image)
            : ((general_images = !1),
              (current_variant_ids = all_variant_images[image.id]
                ? all_variant_images[image.id]
                : current_variant_ids).forEach(function (variant_id) {
                variants[variant_id].push(image);
              }));
        });
      }
      function is_correct_theme_selected() {
        let excluded_theme_names =
          "Shogun Page Builder App, GemPages Page Builder App, LayoutHub Easy Page Builder App, MagicZoomPlus App, MyCustomTheme, PageFly Advanced Page Builder App";
        if (window.BOOMR && window.BOOMR.themeName) {
          let theme_name = "Focal".toLowerCase(),
            boomr_theme = window.BOOMR.themeName.toLowerCase();
          if (excluded_theme_names.includes(theme_name)) return !0;
          if (!theme_name.includes(boomr_theme))
            return (
              console.log(
                `If StarApps Variant Image app is not working, please select ${window.BOOMR.themeName} as theme in app dashboard.`
              ),
              !1
            );
        }
        return !0;
      }
      function is_restrictable() {
        return (
          ("include_selected" == limit_on_product &&
            0 ==
              /via_enabled|viaenabled|via-enabled|__via_enabled/.test(
                product_tags.toLowerCase()
              )) ||
          ("exclude_selected" == limit_on_product &&
            1 ==
              /via_disabled|via-disabled|viadisabled|__via_disabled/.test(
                product_tags.toLowerCase()
              ))
        );
      }
      function get_ready_with_data(_callback) {
        var DONE = 4,
          OK = 200,
          xhr_for_js = new XMLHttpRequest();
        return (
          xhr_for_js.open("GET", product_url + ".js", !0),
          xhr_for_js.send(),
          (xhr_for_js.onreadystatechange = function () {
            if (xhr_for_js.readyState === DONE && xhr_for_js.status === OK) {
              if (
                ((productJson = JSON.parse(xhr_for_js.responseText)),
                (product_tags = productJson.tags.join()),
                (void 0 === productJson.media ||
                  0 == productJson.media.length) &&
                  0 == productJson.images.length)
              )
                return;
              assign_variants_media(productJson);
              var xhr_for_json = new XMLHttpRequest();
              xhr_for_json.open("GET", product_url + ".json", !0),
                xhr_for_json.send(),
                (xhr_for_json.onreadystatechange = function () {
                  xhr_for_json.readyState === DONE &&
                    xhr_for_json.status === OK &&
                    (assign_variant_images(
                      JSON.parse(xhr_for_json.responseText).product.images
                    ),
                    _callback());
                });
            }
          }),
          !0
        );
      }
      function processJSONInformation() {
        (product_tags = productJson.tags.join()),
          assign_variants_media(productJson),
          assign_variant_images(productJson.product_images),
          execute_app_code();
      }
      function run() {
        if (is_product_preview)
          try {
            (productJson = JSON.parse(
              document.querySelector("[sa-product-json]").innerText
            )),
              processJSONInformation();
          } catch (e) {
            setTimeout(function () {
              run();
            }, 100);
          }
        else if (document.querySelector("[sa-product-json]"))
          try {
            (productJson = JSON.parse(
              document.querySelector("[sa-product-json]").innerText
            )).media && processJSONInformation();
          } catch (e) {}
        is_product_preview ||
          (productJson && productJson.media) ||
          get_ready_with_data(execute_app_code);
      }
      function execute_app_code() {
        if (
          !(
            is_restrictable() ||
            (1 == product_media.length && 1 == product_images.length)
          )
        ) {
          is_correct_theme_selected();
          var nTimer = setInterval(function () {
            if (
              "interactive" == document.readyState ||
              "complete" == document.readyState
            ) {
              function Delegate(root) {
                (this.listenerMap = [{}, {}]),
                  root && this.root(root),
                  (this.handle = Delegate.prototype.handle.bind(this)),
                  (this._removedListeners = []);
              }
              function matchesTag(tagName, element) {
                return tagName.toLowerCase() === element.tagName.toLowerCase();
              }
              function matchesRoot(selector, element) {
                return this.rootElement === window
                  ? element === document ||
                      element === document.documentElement ||
                      element === window
                  : this.rootElement === element;
              }
              function matchesId(id, element) {
                return id === element.id;
              }
              function triggerEvent(element, name, data = {}) {
                element.dispatchEvent(
                  new CustomEvent(name, { bubbles: !0, detail: data })
                );
              }
              clearInterval(nTimer),
                (Delegate.prototype.root = function (root) {
                  const listenerMap = this.listenerMap;
                  let eventType;
                  if (this.rootElement) {
                    for (eventType in listenerMap[1])
                      listenerMap[1].hasOwnProperty(eventType) &&
                        this.rootElement.removeEventListener(
                          eventType,
                          this.handle,
                          !0
                        );
                    for (eventType in listenerMap[0])
                      listenerMap[0].hasOwnProperty(eventType) &&
                        this.rootElement.removeEventListener(
                          eventType,
                          this.handle,
                          !1
                        );
                  }
                  if (!root || !root.addEventListener)
                    return this.rootElement && delete this.rootElement, this;
                  for (eventType in ((this.rootElement = root), listenerMap[1]))
                    listenerMap[1].hasOwnProperty(eventType) &&
                      this.rootElement.addEventListener(
                        eventType,
                        this.handle,
                        !0
                      );
                  for (eventType in listenerMap[0])
                    listenerMap[0].hasOwnProperty(eventType) &&
                      this.rootElement.addEventListener(
                        eventType,
                        this.handle,
                        !1
                      );
                  return this;
                }),
                (Delegate.prototype.captureForType = function (eventType) {
                  return (
                    -1 !==
                    [
                      "blur",
                      "error",
                      "focus",
                      "load",
                      "resize",
                      "scroll",
                    ].indexOf(eventType)
                  );
                }),
                (Delegate.prototype.on = function (
                  eventType,
                  selector,
                  handler,
                  useCapture
                ) {
                  let root, listenerMap, matcher, matcherParam;
                  if (!eventType)
                    throw new TypeError("Invalid event type: " + eventType);
                  if (
                    ("function" == typeof selector &&
                      ((useCapture = handler),
                      (handler = selector),
                      (selector = null)),
                    void 0 === useCapture &&
                      (useCapture = this.captureForType(eventType)),
                    "function" != typeof handler)
                  )
                    throw new TypeError("Handler must be a type of Function");
                  return (
                    (root = this.rootElement),
                    (listenerMap = this.listenerMap[useCapture ? 1 : 0]),
                    listenerMap[eventType] ||
                      (root &&
                        root.addEventListener(
                          eventType,
                          this.handle,
                          useCapture
                        ),
                      (listenerMap[eventType] = [])),
                    selector
                      ? /^[a-z]+$/i.test(selector)
                        ? ((matcherParam = selector), (matcher = matchesTag))
                        : /^#[a-z0-9\-_]+$/i.test(selector)
                        ? ((matcherParam = selector.slice(1)),
                          (matcher = matchesId))
                        : ((matcherParam = selector),
                          (matcher = Element.prototype.matches))
                      : ((matcherParam = null),
                        (matcher = matchesRoot.bind(this))),
                    listenerMap[eventType].push({
                      selector: selector,
                      handler: handler,
                      matcher: matcher,
                      matcherParam: matcherParam,
                    }),
                    this
                  );
                }),
                (Delegate.prototype.off = function (
                  eventType,
                  selector,
                  handler,
                  useCapture
                ) {
                  let i, listener, listenerMap, listenerList, singleEventType;
                  if (
                    ("function" == typeof selector &&
                      ((useCapture = handler),
                      (handler = selector),
                      (selector = null)),
                    void 0 === useCapture)
                  )
                    return (
                      this.off(eventType, selector, handler, !0),
                      this.off(eventType, selector, handler, !1),
                      this
                    );
                  if (
                    ((listenerMap = this.listenerMap[useCapture ? 1 : 0]),
                    !eventType)
                  ) {
                    for (singleEventType in listenerMap)
                      listenerMap.hasOwnProperty(singleEventType) &&
                        this.off(singleEventType, selector, handler);
                    return this;
                  }
                  if (
                    ((listenerList = listenerMap[eventType]),
                    !listenerList || !listenerList.length)
                  )
                    return this;
                  for (i = listenerList.length - 1; i >= 0; i--)
                    (listener = listenerList[i]),
                      (selector && selector !== listener.selector) ||
                        (handler && handler !== listener.handler) ||
                        (this._removedListeners.push(listener),
                        listenerList.splice(i, 1));
                  return (
                    listenerList.length ||
                      (delete listenerMap[eventType],
                      this.rootElement &&
                        this.rootElement.removeEventListener(
                          eventType,
                          this.handle,
                          useCapture
                        )),
                    this
                  );
                }),
                (Delegate.prototype.handle = function (event) {
                  let i, l;
                  const type = event.type;
                  let root,
                    phase,
                    listener,
                    returned,
                    target,
                    listenerList = [];
                  const eventIgnore = "ftLabsDelegateIgnore";
                  if (!0 === event[eventIgnore]) return;
                  switch (
                    ((target = event.target),
                    3 === target.nodeType && (target = target.parentNode),
                    target.correspondingUseElement &&
                      (target = target.correspondingUseElement),
                    (root = this.rootElement),
                    (phase =
                      event.eventPhase ||
                      (event.target !== event.currentTarget ? 3 : 2)),
                    phase)
                  ) {
                    case 1:
                      listenerList = this.listenerMap[1][type];
                      break;
                    case 2:
                      this.listenerMap[0] &&
                        this.listenerMap[0][type] &&
                        (listenerList = listenerList.concat(
                          this.listenerMap[0][type]
                        )),
                        this.listenerMap[1] &&
                          this.listenerMap[1][type] &&
                          (listenerList = listenerList.concat(
                            this.listenerMap[1][type]
                          ));
                      break;
                    case 3:
                      listenerList = this.listenerMap[0][type];
                  }
                  let ret,
                    toFire = [];
                  for (l = listenerList.length; target && l; ) {
                    for (
                      i = 0;
                      i < l && ((listener = listenerList[i]), listener);
                      i++
                    )
                      target.tagName &&
                      ["button", "input", "select", "textarea"].indexOf(
                        target.tagName.toLowerCase()
                      ) > -1 &&
                      target.hasAttribute("disabled")
                        ? (toFire = [])
                        : listener.matcher.call(
                            target,
                            listener.matcherParam,
                            target
                          ) && toFire.push([event, target, listener]);
                    if (target === root) break;
                    if (
                      ((l = listenerList.length),
                      (target = target.parentElement || target.parentNode),
                      target instanceof HTMLDocument)
                    )
                      break;
                  }
                  for (i = 0; i < toFire.length; i++)
                    if (
                      !(this._removedListeners.indexOf(toFire[i][2]) > -1) &&
                      ((returned = this.fire.apply(this, toFire[i])),
                      !1 === returned)
                    ) {
                      (toFire[i][0][eventIgnore] = !0),
                        toFire[i][0].preventDefault(),
                        (ret = !1);
                      break;
                    }
                  return ret;
                }),
                (Delegate.prototype.fire = function (event, target, listener) {
                  return listener.handler.call(target, event, target);
                }),
                (Delegate.prototype.destroy = function () {
                  this.off(), this.root();
                });
              class CustomHTMLElement {
                constructor(el) {
                  (this.el = el), (this._hasSectionReloaded = !1);
                }
                get rootDelegate() {
                  return (this._rootDelegate =
                    this._rootDelegate ||
                    new Delegate(document.documentElement));
                }
                get delegate() {
                  return (this._delegate =
                    this._delegate || new Delegate(this.el));
                }
                showLoadingBar() {
                  triggerEvent(document.documentElement, "theme:loading:start");
                }
                hideLoadingBar() {
                  triggerEvent(document.documentElement, "theme:loading:end");
                }
                untilVisible(
                  intersectionObserverOptions = {
                    rootMargin: "0px",
                    threshold: 0.2,
                  }
                ) {
                  const onBecameVisible = () => {
                    this.classList.add("became-visible"),
                      (this.style.opacity = "1");
                  };
                  return new Promise((resolve) => {
                    window.IntersectionObserver
                      ? ((this.intersectionObserver = new IntersectionObserver(
                          (event) => {
                            event[0].isIntersecting &&
                              (this.intersectionObserver.disconnect(),
                              requestAnimationFrame(() => {
                                resolve(), onBecameVisible();
                              }));
                          },
                          intersectionObserverOptions
                        )),
                        this.intersectionObserver.observe(this))
                      : (resolve(), onBecameVisible());
                  });
                }
                disconnectedCallback() {
                  var _a;
                  this.delegate.destroy(),
                    this.rootDelegate.destroy(),
                    null == (_a = this.intersectionObserver) || _a.disconnect(),
                    delete this._delegate,
                    delete this._rootDelegate;
                }
              }
              function imageLoaded(image) {
                return new Promise((resolve) => {
                  !image || "IMG" !== image.tagName || image.complete
                    ? resolve()
                    : (image.onload = () => resolve());
                });
              }
              var ProductMedia2 = class extends CustomHTMLElement {
                  constructor(el) {
                    super(el),
                      (this.el = el),
                      (this.mainCarousel =
                        this.el.querySelector("flickity-carousel")),
                      this.el.hasAttribute("reveal-on-scroll") &&
                        this.el._setupVisibility(),
                      1 !== this.mainCarousel.childElementCount &&
                        ((this.viewInSpaceElement = this.el.querySelector(
                          "[data-shopify-model3d-id]"
                        )),
                        (this.zoomButton = this.el.querySelector(
                          ".product__zoom-button"
                        )),
                        this.mainCarousel.addEventListener("model:played", () =>
                          this.mainCarousel.setDraggable(!1)
                        ),
                        this.mainCarousel.addEventListener("model:paused", () =>
                          this.mainCarousel.setDraggable(!0)
                        ),
                        this.mainCarousel.addEventListener("video:played", () =>
                          this.mainCarousel.setDraggable(!1)
                        ),
                        this.mainCarousel.addEventListener("video:paused", () =>
                          this.mainCarousel.setDraggable(!0)
                        ),
                        this.mainCarousel.addEventListener(
                          "flickity:ready",
                          this._onFlickityReady.bind(this)
                        ),
                        this.mainCarousel.addEventListener(
                          "flickity:slide-changed",
                          this._onFlickityChanged.bind(this)
                        ),
                        this.mainCarousel.addEventListener(
                          "flickity:slide-settled",
                          this._onFlickitySettled.bind(this)
                        ),
                        this._onFlickityReady());
                  }
                  get thumbnailsPosition() {
                    return window.matchMedia(
                      window.themeVariables.breakpoints.pocket
                    ).matches
                      ? "bottom"
                      : document
                          .querySelector(".product__media[thumbnails-position]")
                          ?.getAttribute("thumbnails-position");
                  }
                  async _setupVisibility() {
                    await this.el.untilVisible();
                    const flickityInstance = await this.mainCarousel
                        .flickityInstance,
                      image = flickityInstance
                        ? flickityInstance.selectedElement.querySelector("img")
                        : this.querySelector(
                            ".product__media-image-wrapper img"
                          ),
                      prefersReducedMotion =
                        MediaFeatures.prefersReducedMotion();
                    await imageLoaded(image);
                    const animation = new CustomAnimation(
                      new ParallelEffect([
                        new CustomKeyframeEffect(
                          image,
                          {
                            opacity: [0, 1],
                            transform: [
                              `scale(${prefersReducedMotion ? 1 : 1.1})`,
                              "scale(1)",
                            ],
                          },
                          {
                            duration: 500,
                            easing: "cubic-bezier(0.65, 0, 0.35, 1)",
                          }
                        ),
                        new ParallelEffect(
                          Array.from(
                            this.querySelectorAll(
                              ".product__thumbnail-item:not(.is-filtered)"
                            )
                          ).map(
                            (item, index) =>
                              new CustomKeyframeEffect(
                                item,
                                {
                                  opacity: [0, 1],
                                  transform:
                                    "left" === this.thumbnailsPosition
                                      ? [
                                          `translateY(${
                                            prefersReducedMotion ? 0 : "40px"
                                          })`,
                                          "translateY(0)",
                                        ]
                                      : [
                                          `translateX(${
                                            prefersReducedMotion ? 0 : "50px"
                                          })`,
                                          "translateX(0)",
                                        ],
                                },
                                {
                                  duration: 250,
                                  delay: prefersReducedMotion ? 0 : 100 * index,
                                  easing: "cubic-bezier(0.75, 0, 0.175, 1)",
                                }
                              )
                          )
                        ),
                      ])
                    );
                    this._hasSectionReloaded
                      ? animation.finish()
                      : animation.play();
                  }
                  async _onFlickityReady() {
                    const flickityInstance = await this.mainCarousel
                      .flickityInstance;
                    ["video", "external_video"].includes(
                      flickityInstance.selectedElement.getAttribute(
                        "data-media-type"
                      )
                    ) &&
                      this.el.hasAttribute("autoplay-video") &&
                      flickityInstance.selectedElement.firstElementChild.play();
                  }
                  async _onFlickityChanged() {
                    (await this.mainCarousel.flickityInstance).cells.forEach(
                      (item) => {
                        let mediaType =
                          item.element.getAttribute("data-media-type");
                        ["external_video", "video", "model"].includes(
                          mediaType
                        ) &&
                          (item.element.firstElementChild.pause(),
                          item.element.querySelector(mediaType)?.pause());
                      }
                    );
                  }
                  async _onFlickitySettled() {
                    const selectedSlide = (
                      await this.mainCarousel.flickityInstance
                    ).selectedElement;
                    switch (
                      (this.zoomButton &&
                        (this.zoomButton.hidden =
                          "image" !==
                          selectedSlide.getAttribute("data-media-type")),
                      this.viewInSpaceElement &&
                        this.viewInSpaceElement.setAttribute(
                          "data-shopify-model3d-id",
                          this.viewInSpaceElement.getAttribute(
                            "data-shopify-model3d-default-id"
                          )
                        ),
                      selectedSlide.getAttribute("data-media-type"))
                    ) {
                      case "model":
                        this.viewInSpaceElement.setAttribute(
                          "data-shopify-model3d-id",
                          selectedSlide.getAttribute("data-media-id")
                        ),
                          selectedSlide.firstElementChild.play();
                        break;
                      case "external_video":
                      case "video":
                        this.el.hasAttribute("autoplay-video") &&
                          selectedSlide.firstElementChild.play();
                    }
                  }
                },
                MediaFeatures = class {
                  static prefersReducedMotion() {
                    return window.matchMedia("(prefers-reduced-motion: reduce)")
                      .matches;
                  }
                  static supportsHover() {
                    return window.matchMedia("(any-hover: hover)").matches;
                  }
                };
              function getSiblings(element, filter, includeSelf = !1) {
                let siblings = [],
                  currentElement = element;
                for (
                  ;
                  (currentElement = currentElement.previousElementSibling);

                )
                  (filter && !currentElement.matches(filter)) ||
                    siblings.push(currentElement);
                for (
                  includeSelf && siblings.push(element),
                    currentElement = element;
                  (currentElement = currentElement.nextElementSibling);

                )
                  (filter && !currentElement.matches(filter)) ||
                    siblings.push(currentElement);
                return siblings;
              }
              var FlickityControls = class extends CustomHTMLElement {
                constructor(el) {
                  super(el), (this.el = el);
                  this.flickityCarousel.addEventListener(
                    "flickity:ready",
                    this._onSlideChanged.bind(this, !1)
                  ),
                    this.flickityCarousel.addEventListener(
                      "flickity:slide-changed",
                      this._onSlideChanged.bind(this, !0)
                    );
                }
                get flickityCarousel() {
                  return (this._flickityCarousel =
                    this._flickityCarousel ||
                    document.querySelector(
                      "variant-slider.starapps flickity-carousel"
                    ));
                }
                async _onSlideChanged(animate = !0) {
                  let flickityInstance = await this.flickityCarousel
                    .flickityInstance;
                  Array.from(
                    this.el.querySelectorAll(
                      `[aria-controls="${flickityInstance.selectedElement.id}"]`
                    )
                  ).forEach((activeItem) => {
                    activeItem.setAttribute("aria-current", "true"),
                      getSiblings(activeItem).forEach((sibling) =>
                        sibling.removeAttribute("aria-current")
                      ),
                      requestAnimationFrame(() => {
                        if (
                          activeItem.offsetParent &&
                          activeItem.offsetParent !== this
                        ) {
                          const windowHalfHeight =
                              activeItem.offsetParent.clientHeight / 2,
                            windowHalfWidth =
                              activeItem.offsetParent.clientWidth / 2;
                          activeItem.offsetParent.scrollTo({
                            behavior: animate ? "smooth" : "auto",
                            top:
                              activeItem.offsetTop -
                              windowHalfHeight +
                              activeItem.clientHeight / 2,
                            left:
                              activeItem.offsetLeft -
                              windowHalfWidth +
                              activeItem.clientWidth / 2,
                          });
                        }
                      });
                  });
                }
              };
              var media_used,
                product_media_clone,
                product_media_selector,
                carousel,
                thumbnail_selector,
                dots_selector,
                media_style,
                photoswipe_container;
              create_element_append_to_body("div", "multi-variant-info"),
                create_element_append_to_body("div", "multi-variant-thumb"),
                create_element_append_to_body("div", "multi-variant-dots");
              var zTimer = setInterval(function () {
                if (
                  "object" == typeof flickity &&
                  "function" == typeof window.ThemeFlickity
                ) {
                  clearInterval(zTimer),
                    (product_media_selector =
                      document.querySelector("product-media")),
                    (carousel =
                      product_media_selector.querySelector(
                        "flickity-carousel"
                      )),
                    (thumbnail_selector = product_media_selector.querySelector(
                      "flickity-controls .product__thumbnail-list-inner"
                    )),
                    (dots_selector = product_media_selector.querySelector(
                      "flickity-controls .dots-nav"
                    )),
                    (media_style = product_media_selector.style.cssText),
                    ((product_media_clone = product_media_selector.cloneNode(
                      !0
                    )).querySelector(
                      "flickity-controls .product__thumbnail-list-inner"
                    ).style.display = "none"),
                    product_media_clone.querySelector(
                      ".product__zoom-button"
                    ) &&
                      ((photoswipe_container =
                        product_media_selector.querySelector(
                          "product-image-zoom"
                        ).outerHTML),
                      product_media_selector
                        .querySelector("product-image-zoom")
                        .remove(),
                      (product_media_clone.querySelector(
                        ".product__zoom-button"
                      ).style.display = "none")),
                    (document.getElementById("multi-variant-info").innerHTML =
                      carousel.innerHTML),
                    (document.getElementById("multi-variant-thumb").innerHTML =
                      thumbnail_selector.innerHTML),
                    (document.getElementById("multi-variant-dots").innerHTML =
                      dots_selector ? dots_selector.innerHTML : ""),
                    document
                      .querySelectorAll(
                        "#multi-variant-info .is-initial-selected"
                      )
                      .forEach((obj) => {
                        obj.classList.remove("is-initial-selected");
                      }),
                    document
                      .querySelectorAll(
                        "#multi-variant-info .is-filtered, #multi-variant-thumb .is-filtered"
                      )
                      .forEach((obj) => {
                        obj.classList.remove("is-filtered");
                      }),
                    document
                      .querySelectorAll(
                        "#multi-variant-info [reveal], #multi-variant-thumb [reveal], #multi-variant-dots [reveal]"
                      )
                      .forEach((obj) => {
                        obj.removeAttribute("reveal");
                      }),
                    document.addEventListener(
                      "variant:changed",
                      function (event) {
                        try {
                          var variant_id = event.detail.variant.id;
                          (selection_vid = variant_id),
                            focal2_change_images(variant_id);
                        } catch (e) {}
                      }
                    );
                  var selectors = document.querySelectorAll(
                    'select, .panda-swatch, .single-option-selector, label, .swatches .swatch-selector, form[action="/cart/add"]'
                  );
                  function variant_change_event() {
                    setTimeout(function () {
                      (variant_id = find_current_variant()),
                        selection_vid != variant_id &&
                          (focal2_change_images(variant_id),
                          (selection_vid = variant_id));
                    }, 100);
                  }
                  selectors &&
                    Object.entries(selectors).forEach(([index, selector]) => {
                      selector.addEventListener(
                        "click",
                        variant_change_event,
                        !1
                      ),
                        selector.addEventListener(
                          "change",
                          variant_change_event,
                          !1
                        );
                    }),
                    focal2_change_images();
                } else if (
                  "function" == typeof $ &&
                  "function" == typeof $.fn.slick
                ) {
                  clearInterval(zTimer);
                  var all_images = (media_used =
                    $(".product__slideshow--main [data-media-id]").length > 0)
                    ? product_media
                    : product_images;
                  $(".product__slideshow--nav img").each(function (index, obj) {
                    $(obj).attr("data-image-id", all_images[index].id);
                  }),
                    $("#multi-variant-info").html(
                      $(".product__slideshow--main").html()
                    ),
                    $("#multi-variant-info img.lazyloading")
                      .removeClass("lazyloading")
                      .addClass("lazyload"),
                    $("#multi-variant-thumb").html(
                      $(".product__slideshow--nav").html()
                    ),
                    focal_change_images(),
                    $("body").on("change", "select", function () {
                      setTimeout(function () {
                        (variant_id = find_current_variant()),
                          selection_vid != variant_id &&
                            (focal_change_images(variant_id),
                            (selection_vid = variant_id));
                      }, 100);
                    });
                }
              }, 50);
              function focal2_change_images(variant_id) {
                if (
                  ((variant_images = find_variant_media(variant_id)),
                  !is_array_equal(last_variant_images, variant_images))
                ) {
                  last_variant_images = variant_images;
                  var slide_images = "",
                    thumb_images = "",
                    dots_images = "";
                  variant_images.forEach((image, index) => {
                    let obj = document.querySelector(
                      "#multi-variant-info .product__media-item[data-media-id='" +
                        image.id +
                        "']"
                    );
                    obj.setAttribute("data-original-position", index),
                      obj.removeAttribute("style"),
                      obj.classList.remove("is-selected"),
                      (slide_images += obj.outerHTML);
                    let thumb = document.querySelector(
                      "#multi-variant-thumb button[data-media-id='" +
                        image.id +
                        "']"
                    );
                    if (
                      (thumb.setAttribute("data-index", index),
                      thumb.removeAttribute("style"),
                      thumb.removeAttribute("reveal"),
                      (thumb_images += thumb.outerHTML),
                      dots_selector)
                    ) {
                      let dot = document.querySelector(
                        "#multi-variant-dots button[data-media-id='" +
                          image.id +
                          "']"
                      );
                      dot.removeAttribute("style"),
                        dot.setAttribute("data-index", index),
                        (dots_images += dot.outerHTML);
                    }
                  }),
                    (product_media_selector.style.display = "none"),
                    (product_media_selector.style.opacity = 0),
                    product_media_clone
                      .querySelector("flickity-carousel")
                      .classList.remove("flickity-enabled", "is-draggable"),
                    (product_media_clone.querySelector(
                      "flickity-carousel"
                    ).innerHTML = slide_images),
                    (product_media_clone.querySelector(
                      "flickity-controls .product__thumbnail-list-inner"
                    ).innerHTML = thumb_images),
                    dots_selector &&
                      (product_media_clone.querySelector(
                        "flickity-controls .dots-nav"
                      ).innerHTML = dots_images);
                  var variant_slider =
                    '<variant-slider class="product__media starapps" style="visibility:hidden">' +
                    product_media_clone.innerHTML +
                    "</variant-slider>";
                  document.querySelector(".product__media.starapps")?.remove(),
                    product_media_selector.insertAdjacentHTML(
                      "afterend",
                      variant_slider
                    );
                  var el = document.querySelector(".product__media.starapps");
                  (el.style.cssText = media_style),
                    (el.style.opacity = 0),
                    (el.style.visibility = "");
                  var zoom = el.querySelector("product-image-zoom");
                  el.querySelectorAll("native-video").forEach((item) => {
                    if (!item.querySelector("video")) {
                      var node = item
                        .querySelector("template")
                        .content.firstElementChild.cloneNode(!0);
                      (item.innerHTML = ""), item.appendChild(node);
                    }
                  });
                  new ProductMedia2(el);
                  var controls = el.querySelector("flickity-controls");
                  new FlickityControls(controls);
                  var slider = el.querySelector("flickity-carousel"),
                    flkt = window.ThemeFlickity.data(slider);
                  1 == variant_images.length &&
                    el
                      .querySelector(".product__media-item")
                      .classList.add("is-selected"),
                    1 == variant_images.length && hide_single_thumb
                      ? (controls.style.opacity = 0)
                      : (controls.style.opacity = 1);
                  var kTimer = setInterval(function () {
                    (1 == variant_images.length ||
                      (el.querySelector(".flickity-viewport") &&
                        el.querySelector(".flickity-viewport").offsetHeight >
                          0)) &&
                      (clearInterval(kTimer),
                      (el.style.transition = "opacity 0.8s ease 0s"),
                      (el.style.opacity = 1),
                      (el.querySelector(
                        "flickity-controls .product__thumbnail-list-inner"
                      ).style.display = ""),
                      !flkt && (flkt = window.ThemeFlickity.data(slider)),
                      flkt && flkt.resize(),
                      zoom &&
                        (el.querySelector(
                          ".product__zoom-button"
                        ).style.display = ""));
                  }, 10);
                  el
                    .querySelector('flickity-controls [data-action="prev"]')
                    .addEventListener("click", function () {
                      !flkt && (flkt = window.ThemeFlickity.data(slider)),
                        flkt && flkt.previous();
                    }),
                    el
                      .querySelector('flickity-controls [data-action="next"]')
                      .addEventListener("click", function () {
                        !flkt && (flkt = window.ThemeFlickity.data(slider)),
                          flkt && flkt.next();
                      }),
                    el
                      .querySelectorAll(
                        'flickity-controls [data-action="select"]'
                      )
                      .forEach((item) => {
                        item.addEventListener("click", function () {
                          if ((flkt = window.ThemeFlickity.data(slider))) {
                            let index = parseInt(this.dataset.index);
                            flkt.select(index);
                          }
                        });
                      }),
                    el.addEventListener("click", function (event) {
                      event.target.classList.contains("pswp__button--close") &&
                        setTimeout(function () {
                          el.querySelector("product-image-zoom").remove(),
                            el.insertAdjacentHTML(
                              "beforeend",
                              photoswipe_container
                            );
                        }, 100);
                    }),
                    el
                      .querySelector('flickity-controls [data-action="select"]')
                      ?.click();
                }
              }
              function focal_change_images(variant_id) {
                if (
                  ((variant_images = media_used
                    ? find_variant_media(variant_id)
                    : find_variant_images(variant_id)),
                  !is_array_equal(last_variant_images, variant_images))
                ) {
                  last_variant_images = variant_images;
                  var slide_images = "",
                    thumb_images = "";
                  $.each(variant_images, function (v_index, v_image) {
                    (slide_images += media_used
                      ? $(
                          "#multi-variant-info li:not(.slick-cloned)[data-media-id='" +
                            v_image.id +
                            "']"
                        )
                          .clone()
                          .removeAttr("style")
                          .wrap("<div></div>")
                          .parent()
                          .html()
                      : $(
                          "#multi-variant-info li:not(.slick-cloned)[data-image-id='" +
                            v_image.id +
                            "']"
                        )
                          .clone()
                          .removeAttr("style")
                          .wrap("<div></div>")
                          .parent()
                          .html()),
                      (thumb_images += $(
                        "#multi-variant-thumb img[data-image-id='" +
                          v_image.id +
                          "']"
                      )
                        .closest("[data-slide-index]")
                        .clone()
                        .attr("data-slide-index", v_index)
                        .wrap("<div></div>")
                        .parent()
                        .html());
                  }),
                    $(".product__slideshow--nav").html(thumb_images),
                    1 == variant_images.length && hide_single_thumb
                      ? $(".product__slideshow--nav").hide()
                      : $(".product__slideshow--nav").show();
                  try {
                    $(".product__slideshow--main").slick("unslick");
                  } catch (e) {}
                  (slide_images =
                    '<li><ul class="product__slides_sub">' +
                    slide_images +
                    "</ul></li>"),
                    $(".product__slideshow--main").html(slide_images),
                    initProductSlideshow($(".product__slides_sub")),
                    setTimeout(function () {
                      $(".product__slideshow--nav img:first").trigger("click");
                    }, 100);
                }
              }
              function initProductSlideshow(productSlideshow) {
                productSlideshow.find(".product__slideshow-slide");
                var isZoomEnabled = productSlideshow.attr("data-zoom-enabled"),
                  zoomMagnification = productSlideshow.attr(
                    "data-zoom-magnification"
                  );
                productSlideshow
                  .off("init afterChange")
                  .on("init afterChange", function (event, slick) {
                    var currentSlide = $(slick.$slides[slick.currentSlide]);
                    "true" !== isZoomEnabled ||
                      currentSlide.attr("data-slide-initialized") ||
                      Modernizr.touchevents ||
                      currentSlide.zoom({
                        url: currentSlide.attr("data-image-large-url"),
                        touch: !1,
                        magnify: zoomMagnification,
                        onZoomIn: function () {
                          $(this)
                            .prev()
                            .addClass("product__slideshow-image--zoomed");
                        },
                        onZoomOut: function () {
                          $(this)
                            .prev()
                            .removeClass("product__slideshow-image--zoomed");
                        },
                      });
                  }),
                  productSlideshow.slick({
                    useTransform: !0,
                    adaptiveHeight: !0,
                    initialSlide: 0,
                    dots: !0,
                  }),
                  $(".product__slideshow-nav-image")
                    .off("click")
                    .on("click", function (e) {
                      productSlideshow.slick(
                        "slickGoTo",
                        parseInt($(this).attr("data-slide-index"))
                      ),
                        e.preventDefault();
                    });
              }
            }
          }, 10);
        }
      }
      run();
    }
  }
};
variantImageAutomator();
